<template>
	<div id="wrap">
		<div class="title1">短信服务 <img class="sanjiao" src="/static/qmsj/img/duanxin/xiangyou.png" alt=""> 发送记录

			<a @click="jump_m('duanxin')">
				<p class="returnBtn">返回</p>
			</a>
			<a @click="jump_m('chongzhi')">
				<p class="returnBtn" style="margin-right: 30px">充值</p>
			</a>
		</div>
		<div class="count_nei1">
			<div class="cont_title">发送记录</div>
		</div>

		<div style="width: 100%;padding-left: 45px;margin-top: 20px">
			<!--<div class='col-md-2'>-->
				<div class="form-group" style="float: left;">
					<div class='input-group date' id='datetimeStart'>
						<el-date-picker
					      v-model="start_time"
					      size="small"
					      style="width: 150px;"
					      type="date"
					      value-format="yyyy-MM-dd"
					      placeholder="开始日期">
					    </el-date-picker>
					</div>
				</div>
			<!--</div>-->
			<!--<div class='col-md-2'>-->
				<div class="form-group" style="float: left;margin: 0 10px 0 15px;">
					<div class='input-group date' id='datetimeEnd'>
						<el-date-picker
					      v-model="end_time"
					      size="small"
					      value-format="yyyy-MM-dd"
					      style="width: 150px;"
					      type="date"
					      placeholder="结束日期">
					    </el-date-picker>
					</div>
				</div>
			<!--</div>-->
			<div class="shijian3 el-icon-search" @click="get_list"></div>
			<!-- <div class="col-md-2">
        <p class="chzongji1">总计：条</p>
	    </div>
	    <div class="col-md-2">
	        <p class="chzongji2">元</p>
	    </div> -->
		</div>
		<div style="width: 100%;height: 10px;clear: both"></div>
		<div class="chongzhitable">
			<table class="table table-striped table-hover">
				<thead>
					<tr style="height: 42px;line-height: 42px;font-size: 14px;background:#f1eff2;padding: 0 ">
						<th style="padding-bottom:10px;text-align: center ">姓名</th>
						<th style="padding-bottom:10px;text-align: center ">电话</th>
						<th style="padding-bottom:10px;text-align: center ">时间</th>
						<th style="padding-bottom:10px;text-align: center ">模板类型</th>
						<th style="padding-bottom:10px;text-align: center ">发送状态</th>
						<th style="padding-bottom:10px;text-align: center ">发送方式</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="item in database">
						<td style="padding-bottom:10px;text-align: center">{{item.baobao_name}}</td>
						<td style="padding-bottom:10px;text-align: center">{{item.phone}}</td>
						<td style="padding-bottom:10px;text-align: center">{{item.create_time}}</td>
						<td style="padding-bottom:10px;text-align: center">{{item.mb_type}}</td>
						<td style="padding-bottom:10px;text-align: center">{{item.status}}</td>
						<td style="padding-bottom:10px;text-align: center">{{item.type}}</td>
					</tr>
				</tbody>
			</table>
			<div style="padding-top:30px;float: right;">
				<el-pagination
			      @current-change="handleCurrentChange"
			      :current-page.sync="currentPage"
			      :page-size="10"
			      background
			      layout="prev, pager, next, jumper"
			      :total="page_list.count">
			    </el-pagination>
			</div>
		</div>

	</div>
</template>

<script>
	export default {
		data() {
			return {
				token:'',
				currentPage:1,//当前页
				database:[],//数据
				page_list:'',//分页数据
				start_time:'',//开始时间
				end_time:'',//结束时间
			};
		},
		created(){
			this.token = this.$cookies.get('token');
			this.get_list()
		},
		methods: {
			//表格数据
			get_list(){
				 let that = this
		 	  	 $.ajax({
				   url: process.env.apiUrl + 'saas/dx/dxfsjl',
				   type: 'post',
				   data:{
				  	  token:that.token,
				  	  time_start:that.start_time,
				  	  time_end:that.end_time,
				  	  page:that.currentPage
				    },
				    success: function (data, status) {
				        if(data.status == 1){
				        	that.database = data.data
				        	that.page_list = data.map
				        }else{
                            that.database = ''
                            that.page_list = ''
							that.$message.error({
								message:'暂无数据'
							})
						}
		 			},
				    fail: function (err, status) {
				        console.log(err)
				    }
				 })
			},
			//跳转页面
			jump_m(u){
				this.$router.push({path:u})
			},
			//分页
			handleCurrentChange(val) {
		        console.log(`当前页: ${val}`);
		        this.currentPage=val
		        this.get_list()
		    }

		}

	}
</script>

<style scoped>
	@import url("../../../static/qmsj/css/duanxin/chushiyangsh.css");
	@import url("../../../static/qmsj/css/duanxin/fasongjilu.css");
	@import url("../../../static/qmsj/css/duanxin/bootstrap-table.css");
	@import url("../../../static/qmsj/css/duanxin/bootstrap-datetimepicker.min.css");
	.shijian3 {
		display: inline-block;
		border-radius: 4px;
		width: 30px;
		height:30px;
		vertical-align:middle;
		padding-left: 0;
		color: #fff;
		text-align: center;
		line-height: 30px;
		font-size: 18px;
		background-color: #8CBB77;
		cursor: pointer;
	}
	.body {
		padding-left: 45px;
		padding-right: 45px;
	}

	ul {
		list-style: none;
	}

	.cont_title {
		padding-left: 7px;
		height: 24px;
		line-height: 24px;
		font-size: 14px;
		border-left: 6px solid #8CBB77;
		margin-top: 14px;
		margin-bottom: 10px;
	}

	.returnBtn {
		width: 80px;
		height: 24px;
		line-height: 24px;
		color: #fff;
		background: #8CBB77;
		border-radius: 12px;
		text-align: center;
		float: right;
		font-size: 12px;
	}
</style>



// WEBPACK FOOTER //
// src/pages/duanxin/fasongjl.vue